var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 342,
    viewBox: "0 0 342 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 3,
    x2: 2.99999,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18.25,
    y1: 3,
    x2: 18.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33.5,
    y1: 3,
    x2: 33.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 48.75,
    y1: 3,
    x2: 48.75,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 3,
    x2: 64,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 79.25,
    y1: 3,
    x2: 79.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 94.5,
    y1: 3,
    x2: 94.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 109.75,
    y1: 3,
    x2: 109.75,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 3,
    x2: 125,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 140.25,
    y1: 3,
    x2: 140.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 3,
    x2: 155.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 170.75,
    y1: 3,
    x2: 170.75,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 186,
    y1: 3,
    x2: 186,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 262.25,
    y1: 3,
    x2: 262.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 201.25,
    y1: 3,
    x2: 201.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 277.5,
    y1: 3,
    x2: 277.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 216.5,
    y1: 3,
    x2: 216.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 292.75,
    y1: 3,
    x2: 292.75,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 231.75,
    y1: 3,
    x2: 231.75,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 3,
    x2: 308,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 247,
    y1: 3,
    x2: 247,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 323.25,
    y1: 3,
    x2: 323.25,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 338.5,
    y1: 3,
    x2: 338.5,
    y2: 338.6,
    stroke: "#454972",
    strokeWidth: 6,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.08 15.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsPattern);
export default __webpack_public_path__ + "static/media/dots-pattern.c38c5e61eac15dd25c242aa3d4408ecc.svg";
export { ForwardRef as ReactComponent };